export default __webpack_public_path__ + "static/media/tool-icon-horde-cones.efc14055.svg";